import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "내부 패키지",
  "description": "모노레포에서 내부 패키지를 구축하는 방법을 알아봅니다."
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "내부 패키지는 소스 코드가 워크스페이스 내부에 있는 라이브러리입니다. 모노레포 내에서 코드를 공유하기 위해 내부 패키지를 빠르게 만들 수 있으며, 나중에 필요한 경우 npm 레지스트리에 게시하도록 선택할 수 있습니다."
  }, {
    "heading": "",
    "content": "내부 패키지는 npm 레지스트리에서 가져오는 외부 패키지와 유사하게 package.json에 설치하여 리포지토리에서 사용됩니다. 하지만 설치할 버전을 표시하는 대신, 패키지 매니저의 워크스페이스 설치 구문을 사용하여 패키지를 참조할 수 있습니다:"
  }, {
    "heading": "",
    "content": "내부 패키지 생성 가이드에서는 컴파일된 패키지 전략을 사용하여 처음부터 내부 패키지를 구축할 수 있습니다. 이 페이지에서는 외부 패키지를 생성하기 위해 npm 레지스트리에 패키지를 게시하는 것을 포함하여 내부 패키지를 생성하는 다른 전략과 그 트레이드오프에 대해 설명합니다."
  }, {
    "heading": "",
    "content": "그런 다음 외부 패키지를 사용할 때와 마찬가지로 패키지를 코드로 가져올 수 있습니다:"
  }, {
    "heading": "컴파일-전략",
    "content": "라이브러리에서 필요한 것에 따라 세 가지 컴파일 전략 중 하나를 선택할 수 있습니다:"
  }, {
    "heading": "컴파일-전략",
    "content": "Just-in-Time 패키지: 애플리케이션 번들러가 패키지를 사용할 때 컴파일하도록 허용하여 패키지에 대한 최소한의 구성을 생성합니다."
  }, {
    "heading": "컴파일-전략",
    "content": "컴파일된 패키지: 적당한 양의 구성으로 tsc와 같은 빌드 도구나 번들러를 사용하여 패키지를 컴파일합니다."
  }, {
    "heading": "컴파일-전략",
    "content": "게시 가능한 패키지: npm 레지스트리에 게시하기 위해 패키지를 컴파일하고 준비합니다. 이 접근 방식은 가장 많은 구성이 필요합니다."
  }, {
    "heading": "just-in-time-패키지",
    "content": "Just-in-Time 패키지는 이를 사용하는 애플리케이션에 의해 컴파일됩니다. 이는 TypeScript(또는 컴파일되지 않은 JavaScript) 파일을 직접 사용할 수 있음을 의미하며, 이 페이지의 다른 전략보다 훨씬 적은 구성이 필요합니다."
  }, {
    "heading": "just-in-time-패키지",
    "content": "이 전략은 다음과 같은 경우에 가장 유용합니다:"
  }, {
    "heading": "just-in-time-패키지",
    "content": "애플리케이션이 Turbopack, webpack 또는 Vite와 같은 최신 번들러를 사용하여 빌드되는 경우"
  }, {
    "heading": "just-in-time-패키지",
    "content": "구성 및 설정 단계를 피하고 싶은 경우"
  }, {
    "heading": "just-in-time-패키지",
    "content": "패키지에 대한 캐시를 사용할 수 없는 경우에도 애플리케이션의 빌드 시간에 만족하는 경우"
  }, {
    "heading": "just-in-time-패키지",
    "content": "Just-in-Time 패키지의 package.json은 다음과 같이 보일 수 있습니다:"
  }, {
    "heading": "just-in-time-패키지",
    "content": "이 package.json에서 주목해야 할 몇 가지 중요한 사항이 있습니다:"
  }, {
    "heading": "just-in-time-패키지",
    "content": "TypeScript 직접 내보내기: exports 필드는 패키지의 진입점을 표시하며, 이 경우 TypeScript 파일을 직접 참조하고 있습니다. 이는 애플리케이션의 번들러가 빌드 프로세스에서 코드를 사용할 때 컴파일하기 때문에 가능합니다."
  }, {
    "heading": "just-in-time-패키지",
    "content": "build 스크립트 없음: 이 패키지는 TypeScript를 내보내기 때문에 패키지를 트랜스파일하기 위한 빌드 단계가 필요하지 않습니다. 즉, 워크스페이스에서 작동하도록 이 패키지에 빌드 도구를 구성할 필요가 없습니다."
  }, {
    "heading": "제한-사항-및-트레이드오프",
    "content": "소비자가 트랜스파일하는 경우에만 적용 가능: 이 전략은 패키지가 번들러를 사용하거나 TypeScript를 기본적으로 이해하는 도구에서 사용될 때만 사용할 수 있습니다. 소비자의 번들러는 TypeScript 패키지를 JavaScript로 트랜스파일할 책임이 있습니다. 빌드 또는 패키지의 다른 사용이 TypeScript를 소비할 수 없는 경우 컴파일된 패키지 전략으로 이동해야 합니다."
  }, {
    "heading": "제한-사항-및-트레이드오프",
    "content": "TypeScript paths 사용 불가: 소비자에 의해 트랜스파일되는 라이브러리는 compilerOptions.paths 구성을 사용할 수 없습니다. 이는 TypeScript가 소스 코드가 작성된 패키지에서 트랜스파일된다고 가정하기 때문입니다. TypeScript 5.4 이상을 사용하는 경우 Node.js 하위 경로 import 사용을 권장합니다. 방법을 알아보려면 TypeScript 페이지를 참조하세요."
  }, {
    "heading": "제한-사항-및-트레이드오프",
    "content": "Turborepo는 Just-in-Time 패키지의 빌드를 캐시할 수 없음: 패키지에 자체 build 단계가 없기 때문에 Turborepo에서 캐시할 수 없습니다. 구성을 최소화하고 애플리케이션의 빌드 시간이 괜찮다면 이 트레이드오프가 적절할 수 있습니다."
  }, {
    "heading": "제한-사항-및-트레이드오프",
    "content": "내부 의존성의 오류가 보고됨: TypeScript를 직접 내보낼 때 내부 의존성의 코드에 TypeScript 오류가 있으면 의존하는 패키지의 타입 검사가 실패합니다. 일부 상황에서는 이것이 혼란스럽거나 문제가 될 수 있습니다."
  }, {
    "heading": "컴파일된-패키지",
    "content": "컴파일된 패키지는 tsc(TypeScript 컴파일러)와 같은 빌드 도구를 사용하여 자체 컴파일을 처리하는 패키지입니다."
  }, {
    "heading": "컴파일된-패키지",
    "content": "라이브러리를 컴파일하면 패키지의 진입점으로 사용할 디렉토리(dist, build 등)에 컴파일된 JavaScript 출력이 생성됩니다. 빌드 출력은 태스크의 outputs 키에 추가되면 Turborepo에서 캐시되어 더 빠른 빌드 시간을 가질 수 있습니다."
  }, {
    "heading": "제한-사항-및-트레이드오프-1",
    "content": "TypeScript 컴파일러 사용: 대부분의 컴파일된 패키지는 tsc를 사용해야 합니다. 패키지가 번들러를 사용하는 애플리케이션에서 소비될 가능성이 높기 때문에, 애플리케이션의 번들러가 애플리케이션의 최종 번들에 배포하기 위해 라이브러리 패키지를 준비하고 polyfill, downleveling 및 기타 문제를 처리합니다. 번들러는 패키지 출력에 정적 자산을 번들링하는 것과 같이 필요한 특정 사용 사례가 있는 경우에만 사용해야 합니다."
  }, {
    "heading": "제한-사항-및-트레이드오프-1",
    "content": "더 많은 구성: 컴파일된 패키지는 빌드 출력을 생성하기 위해 더 깊은 지식과 구성이 필요합니다. 관리하고 이해하기 어려울 수 있는 TypeScript 컴파일러를 위한 많은 구성이 있으며, package.json의 sideEffects 키와 같이 번들러를 위해 최적화하기 위한 추가 구성이 있습니다. TypeScript 전용 가이드에서 일부 권장 사항을 찾을 수 있습니다."
  }, {
    "heading": "게시-가능한-패키지",
    "content": "npm 레지스트리에 패키지를 게시하는 것은 이 페이지의 패키징 전략 중 가장 엄격한 요구 사항을 가지고 있습니다. 레지스트리에서 패키지를 다운로드하는 소비자가 패키지를 어떻게 사용할지 전혀 알 수 없기 때문에, 강력한 패키지를 위해 필요한 수많은 구성으로 인해 어려움을 겪을 수 있습니다."
  }, {
    "heading": "게시-가능한-패키지",
    "content": "또한 npm 레지스트리에 패키지를 게시하는 프로세스에는 전문적인 지식과 도구가 필요합니다. 버전 관리, 변경 로그 및 게시 프로세스를 관리하기 위해 changesets를 권장합니다."
  }, {
    "heading": "게시-가능한-패키지",
    "content": "자세한 가이드는 패키지 게시 가이드를 참조하세요."
  }],
  "headings": [{
    "id": "컴파일-전략",
    "content": "컴파일 전략"
  }, {
    "id": "just-in-time-패키지",
    "content": "Just-in-Time 패키지"
  }, {
    "id": "제한-사항-및-트레이드오프",
    "content": "제한 사항 및 트레이드오프"
  }, {
    "id": "컴파일된-패키지",
    "content": "컴파일된 패키지"
  }, {
    "id": "제한-사항-및-트레이드오프-1",
    "content": "제한 사항 및 트레이드오프"
  }, {
    "id": "게시-가능한-패키지",
    "content": "게시 가능한 패키지"
  }]
};
import {PackageManagerTabs, Tab} from '#components/tabs';
export const toc = [{
  depth: 2,
  url: "#컴파일-전략",
  title: _jsx(_Fragment, {
    children: "컴파일 전략"
  })
}, {
  depth: 3,
  url: "#just-in-time-패키지",
  title: _jsx(_Fragment, {
    children: "Just-in-Time 패키지"
  })
}, {
  depth: 4,
  url: "#제한-사항-및-트레이드오프",
  title: _jsx(_Fragment, {
    children: "제한 사항 및 트레이드오프"
  })
}, {
  depth: 3,
  url: "#컴파일된-패키지",
  title: _jsx(_Fragment, {
    children: "컴파일된 패키지"
  })
}, {
  depth: 4,
  url: "#제한-사항-및-트레이드오프-1",
  title: _jsx(_Fragment, {
    children: "제한 사항 및 트레이드오프"
  })
}, {
  depth: 3,
  url: "#게시-가능한-패키지",
  title: _jsx(_Fragment, {
    children: "게시 가능한 패키지"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: ["내부 패키지는 소스 코드가 워크스페이스 내부에 있는 라이브러리입니다. 모노레포 내에서 코드를 공유하기 위해 내부 패키지를 빠르게 만들 수 있으며, 나중에 필요한 경우 ", _jsx(_components.a, {
        href: "/docs/guides/publishing-libraries",
        children: "npm 레지스트리에 게시"
      }), "하도록 선택할 수 있습니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["내부 패키지는 npm 레지스트리에서 가져오는 외부 패키지와 유사하게 ", _jsx(_components.code, {
        children: "package.json"
      }), "에 설치하여 리포지토리에서 사용됩니다. 하지만 설치할 버전을 표시하는 대신, 패키지 매니저의 워크스페이스 설치 구문을 사용하여 패키지를 참조할 수 있습니다:"]
    }), "\n", _jsxs(PackageManagerTabs, {
      children: [_jsx(Tab, {
        value: "pnpm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables has-highlighted",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./apps/web/package.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"dependencies\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line highlighted",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"@repo/ui\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"workspace:*\""
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })
      }), _jsx(Tab, {
        value: "yarn",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables has-highlighted",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./apps/web/package.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"dependencies\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line highlighted",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"@repo/ui\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"*\""
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })
      }), _jsx(Tab, {
        value: "npm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables has-highlighted",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./apps/web/package.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"dependencies\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line highlighted",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"@repo/ui\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"*\""
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })
      }), _jsx(Tab, {
        value: "bun (Beta)",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables has-highlighted",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./apps/web/package.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"dependencies\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line highlighted",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"@repo/ui\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"workspace:*\""
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })
      })]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "/docs/crafting-your-repository/creating-an-internal-package",
        children: "내부 패키지 생성 가이드"
      }), "에서는 ", _jsx(_components.a, {
        href: "#compiled-packages",
        children: "컴파일된 패키지 전략"
      }), "을 사용하여 처음부터 내부 패키지를 구축할 수 있습니다. 이 페이지에서는 외부 패키지를 생성하기 위해 ", _jsx(_components.a, {
        href: "#publishable-packages",
        children: "npm 레지스트리에 패키지를 게시"
      }), "하는 것을 포함하여 내부 패키지를 생성하는 다른 전략과 그 트레이드오프에 대해 설명합니다."]
    }), "\n", _jsx(_components.p, {
      children: "그런 다음 외부 패키지를 사용할 때와 마찬가지로 패키지를 코드로 가져올 수 있습니다:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables has-highlighted",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./apps/web/app/page.tsx",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M14.23 12.004a2.236 2.236 0 0 1-2.235 2.236 2.236 2.236 0 0 1-2.236-2.236 2.236 2.236 0 0 1 2.235-2.236 2.236 2.236 0 0 1 2.236 2.236zm2.648-10.69c-1.346 0-3.107.96-4.888 2.622-1.78-1.653-3.542-2.602-4.887-2.602-.41 0-.783.093-1.106.278-1.375.793-1.683 3.264-.973 6.365C1.98 8.917 0 10.42 0 12.004c0 1.59 1.99 3.097 5.043 4.03-.704 3.113-.39 5.588.988 6.38.32.187.69.275 1.102.275 1.345 0 3.107-.96 4.888-2.624 1.78 1.654 3.542 2.603 4.887 2.603.41 0 .783-.09 1.106-.275 1.374-.792 1.683-3.263.973-6.365C22.02 15.096 24 13.59 24 12.004c0-1.59-1.99-3.097-5.043-4.032.704-3.11.39-5.587-.988-6.38-.318-.184-.688-.277-1.092-.278zm-.005 1.09v.006c.225 0 .406.044.558.127.666.382.955 1.835.73 3.704-.054.46-.142.945-.25 1.44-.96-.236-2.006-.417-3.107-.534-.66-.905-1.345-1.727-2.035-2.447 1.592-1.48 3.087-2.292 4.105-2.295zm-9.77.02c1.012 0 2.514.808 4.11 2.28-.686.72-1.37 1.537-2.02 2.442-1.107.117-2.154.298-3.113.538-.112-.49-.195-.964-.254-1.42-.23-1.868.054-3.32.714-3.707.19-.09.4-.127.563-.132zm4.882 3.05c.455.468.91.992 1.36 1.564-.44-.02-.89-.034-1.345-.034-.46 0-.915.01-1.36.034.44-.572.895-1.096 1.345-1.565zM12 8.1c.74 0 1.477.034 2.202.093.406.582.802 1.203 1.183 1.86.372.64.71 1.29 1.018 1.946-.308.655-.646 1.31-1.013 1.95-.38.66-.773 1.288-1.18 1.87-.728.063-1.466.098-2.21.098-.74 0-1.477-.035-2.202-.093-.406-.582-.802-1.204-1.183-1.86-.372-.64-.71-1.29-1.018-1.946.303-.657.646-1.313 1.013-1.954.38-.66.773-1.286 1.18-1.868.728-.064 1.466-.098 2.21-.098zm-3.635.254c-.24.377-.48.763-.704 1.16-.225.39-.435.782-.635 1.174-.265-.656-.49-1.31-.676-1.947.64-.15 1.315-.283 2.015-.386zm7.26 0c.695.103 1.365.23 2.006.387-.18.632-.405 1.282-.66 1.933-.2-.39-.41-.783-.64-1.174-.225-.392-.465-.774-.705-1.146zm3.063.675c.484.15.944.317 1.375.498 1.732.74 2.852 1.708 2.852 2.476-.005.768-1.125 1.74-2.857 2.475-.42.18-.88.342-1.355.493-.28-.958-.646-1.956-1.1-2.98.45-1.017.81-2.01 1.085-2.964zm-13.395.004c.278.96.645 1.957 1.1 2.98-.45 1.017-.812 2.01-1.086 2.964-.484-.15-.944-.318-1.37-.5-1.732-.737-2.852-1.706-2.852-2.474 0-.768 1.12-1.742 2.852-2.476.42-.18.88-.342 1.356-.494zm11.678 4.28c.265.657.49 1.312.676 1.948-.64.157-1.316.29-2.016.39.24-.375.48-.762.705-1.158.225-.39.435-.788.636-1.18zm-9.945.02c.2.392.41.783.64 1.175.23.39.465.772.705 1.143-.695-.102-1.365-.23-2.006-.386.18-.63.406-1.282.66-1.933zM17.92 16.32c.112.493.2.968.254 1.423.23 1.868-.054 3.32-.714 3.708-.147.09-.338.128-.563.128-1.012 0-2.514-.807-4.11-2.28.686-.72 1.37-1.536 2.02-2.44 1.107-.118 2.154-.3 3.113-.54zm-11.83.01c.96.234 2.006.415 3.107.532.66.905 1.345 1.727 2.035 2.446-1.595 1.483-3.092 2.295-4.11 2.295-.22-.005-.406-.05-.553-.132-.666-.38-.955-1.834-.73-3.703.054-.46.142-.944.25-1.438zm4.56.64c.44.02.89.034 1.345.034.46 0 .915-.01 1.36-.034-.44.572-.895 1.095-1.345 1.565-.455-.47-.91-.993-1.36-1.565z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsxs(_components.span, {
            className: "line highlighted",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "import"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " { Button } "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "from"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " '@repo/ui'"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "; "
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "export"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: " default"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: " function"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: " Page"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "() {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  return"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " <"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: "Button"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: ">Submit</"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: "Button"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: ">;"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_components.h2, {
      id: "컴파일-전략",
      children: "컴파일 전략"
    }), "\n", _jsx(_components.p, {
      children: "라이브러리에서 필요한 것에 따라 세 가지 컴파일 전략 중 하나를 선택할 수 있습니다:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#just-in-time-packages",
          children: _jsx(_components.strong, {
            children: "Just-in-Time 패키지"
          })
        }), ": 애플리케이션 번들러가 패키지를 사용할 때 컴파일하도록 허용하여 패키지에 대한 최소한의 구성을 생성합니다."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#compiled-packages",
          children: _jsx(_components.strong, {
            children: "컴파일된 패키지"
          })
        }), ": 적당한 양의 구성으로 ", _jsx(_components.code, {
          children: "tsc"
        }), "와 같은 빌드 도구나 번들러를 사용하여 패키지를 컴파일합니다."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#publishable-packages",
          children: _jsx(_components.strong, {
            children: "게시 가능한 패키지"
          })
        }), ": npm 레지스트리에 게시하기 위해 패키지를 컴파일하고 준비합니다. 이 접근 방식은 가장 많은 구성이 필요합니다."]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      id: "just-in-time-패키지",
      children: "Just-in-Time 패키지"
    }), "\n", _jsx(_components.p, {
      children: "Just-in-Time 패키지는 이를 사용하는 애플리케이션에 의해 컴파일됩니다. 이는 TypeScript(또는 컴파일되지 않은 JavaScript) 파일을 직접 사용할 수 있음을 의미하며, 이 페이지의 다른 전략보다 훨씬 적은 구성이 필요합니다."
    }), "\n", _jsx(_components.p, {
      children: "이 전략은 다음과 같은 경우에 가장 유용합니다:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "애플리케이션이 Turbopack, webpack 또는 Vite와 같은 최신 번들러를 사용하여 빌드되는 경우"
      }), "\n", _jsx(_components.li, {
        children: "구성 및 설정 단계를 피하고 싶은 경우"
      }), "\n", _jsx(_components.li, {
        children: "패키지에 대한 캐시를 사용할 수 없는 경우에도 애플리케이션의 빌드 시간에 만족하는 경우"
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["Just-in-Time 패키지의 ", _jsx(_components.code, {
        children: "package.json"
      }), "은 다음과 같이 보일 수 있습니다:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables has-highlighted",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./packages/ui/package.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"name\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"@repo/ui\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"exports\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line highlighted",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"./button\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"./src/button.tsx\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line highlighted",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"./card\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"./src/card.tsx\""
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"scripts\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line highlighted",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"lint\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"eslint . --max-warnings 0\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line highlighted",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"check-types\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"tsc --noEmit\""
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["이 ", _jsx(_components.code, {
        children: "package.json"
      }), "에서 주목해야 할 몇 가지 중요한 사항이 있습니다:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "TypeScript 직접 내보내기"
        }), ": ", _jsx(_components.code, {
          children: "exports"
        }), " 필드는 패키지의 진입점을 표시하며, 이 경우 ", _jsx(_components.strong, {
          children: "TypeScript 파일을 직접 참조"
        }), "하고 있습니다. 이는 애플리케이션의 번들러가 빌드 프로세스에서 코드를 사용할 때 컴파일하기 때문에 가능합니다."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsxs(_components.strong, {
          children: [_jsx(_components.code, {
            children: "build"
          }), " 스크립트 없음"]
        }), ": 이 패키지는 TypeScript를 내보내기 때문에 패키지를 트랜스파일하기 위한 빌드 단계가 필요하지 않습니다. 즉, 워크스페이스에서 작동하도록 이 패키지에 빌드 도구를 구성할 필요가 없습니다."]
      }), "\n"]
    }), "\n", _jsx(_components.h4, {
      id: "제한-사항-및-트레이드오프",
      children: "제한 사항 및 트레이드오프"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "소비자가 트랜스파일하는 경우에만 적용 가능"
        }), ": 이 전략은 패키지가 번들러를 사용하거나 TypeScript를 기본적으로 이해하는 도구에서 사용될 때만 사용할 수 있습니다. 소비자의 번들러는 TypeScript 패키지를 JavaScript로 트랜스파일할 책임이 있습니다. 빌드 또는 패키지의 다른 사용이 TypeScript를 소비할 수 없는 경우 ", _jsx(_components.a, {
          href: "#compiled-packages",
          children: "컴파일된 패키지"
        }), " 전략으로 이동해야 합니다."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsxs(_components.strong, {
          children: ["TypeScript ", _jsx(_components.code, {
            children: "paths"
          }), " 사용 불가"]
        }), ": 소비자에 의해 트랜스파일되는 라이브러리는 ", _jsx(_components.code, {
          children: "compilerOptions.paths"
        }), " 구성을 사용할 수 없습니다. 이는 TypeScript가 소스 코드가 작성된 패키지에서 트랜스파일된다고 가정하기 때문입니다. TypeScript 5.4 이상을 사용하는 경우 ", _jsx(_components.a, {
          href: "https://devblogs.microsoft.com/typescript/announcing-typescript-5-4/#auto-import-support-for-subpath-imports",
          children: "Node.js 하위 경로 import 사용"
        }), "을 권장합니다. 방법을 알아보려면 ", _jsx(_components.a, {
          href: "/docs/guides/tools/typescript#use-nodejs-subpath-imports-instead-of-typescript-compiler-paths",
          children: "TypeScript 페이지"
        }), "를 참조하세요."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Turborepo는 Just-in-Time 패키지의 빌드를 캐시할 수 없음"
        }), ": 패키지에 자체 ", _jsx(_components.code, {
          children: "build"
        }), " 단계가 없기 때문에 Turborepo에서 캐시할 수 없습니다. 구성을 최소화하고 애플리케이션의 빌드 시간이 괜찮다면 이 트레이드오프가 적절할 수 있습니다."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "내부 의존성의 오류가 보고됨"
        }), ": TypeScript를 직접 내보낼 때 내부 의존성의 코드에 TypeScript 오류가 있으면 의존하는 패키지의 타입 검사가 실패합니다. 일부 상황에서는 이것이 혼란스럽거나 문제가 될 수 있습니다."]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      id: "컴파일된-패키지",
      children: "컴파일된 패키지"
    }), "\n", _jsxs(_components.p, {
      children: ["컴파일된 패키지는 ", _jsxs(_components.a, {
        href: "https://www.typescriptlang.org/docs/handbook/compiler-options.html#handbook-content",
        children: [_jsx(_components.code, {
          children: "tsc"
        }), "(TypeScript 컴파일러)"]
      }), "와 같은 빌드 도구를 사용하여 자체 컴파일을 처리하는 패키지입니다."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables has-highlighted",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./packages/ui/package.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"name\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"@repo/ui\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"exports\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"./button\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line highlighted",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"types\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"./src/button.tsx\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line highlighted",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"default\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"./dist/button.js\""
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"./card\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line highlighted",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"types\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"./src/card.tsx\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line highlighted",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"default\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"./dist/card.js\""
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"scripts\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line highlighted",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"tsc\""
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["라이브러리를 컴파일하면 패키지의 진입점으로 사용할 디렉토리(", _jsx(_components.code, {
        children: "dist"
      }), ", ", _jsx(_components.code, {
        children: "build"
      }), " 등)에 컴파일된 JavaScript 출력이 생성됩니다. 빌드 출력은 ", _jsxs(_components.a, {
        href: "/docs/reference/configuration#outputs",
        children: ["태스크의 ", _jsx(_components.code, {
          children: "outputs"
        }), " 키"]
      }), "에 추가되면 Turborepo에서 캐시되어 더 빠른 빌드 시간을 가질 수 있습니다."]
    }), "\n", _jsx(_components.h4, {
      id: "제한-사항-및-트레이드오프-1",
      children: "제한 사항 및 트레이드오프"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "TypeScript 컴파일러 사용"
        }), ": 대부분의 컴파일된 패키지는 ", _jsx(_components.code, {
          children: "tsc"
        }), "를 사용해야 합니다. 패키지가 번들러를 사용하는 애플리케이션에서 소비될 가능성이 높기 때문에, 애플리케이션의 번들러가 애플리케이션의 최종 번들에 배포하기 위해 라이브러리 패키지를 준비하고 polyfill, downleveling 및 기타 문제를 처리합니다. 번들러는 패키지 출력에 정적 자산을 번들링하는 것과 같이 필요한 특정 사용 사례가 있는 경우에만 사용해야 합니다."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "더 많은 구성"
        }), ": 컴파일된 패키지는 빌드 출력을 생성하기 위해 더 깊은 지식과 구성이 필요합니다. 관리하고 이해하기 어려울 수 있는 ", _jsx(_components.a, {
          href: "https://www.typescriptlang.org/docs/handbook/compiler-options.html#compiler-options",
          children: "TypeScript 컴파일러를 위한 많은 구성"
        }), "이 있으며, ", _jsxs(_components.a, {
          href: "https://webpack.js.org/guides/tree-shaking/#mark-the-file-as-side-effect-free",
          children: [_jsx(_components.code, {
            children: "package.json"
          }), "의 ", _jsx(_components.code, {
            children: "sideEffects"
          }), " 키"]
        }), "와 같이 번들러를 위해 최적화하기 위한 추가 구성이 있습니다. ", _jsx(_components.a, {
          href: "/docs/guides/tools/typescript",
          children: "TypeScript 전용 가이드"
        }), "에서 일부 권장 사항을 찾을 수 있습니다."]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      id: "게시-가능한-패키지",
      children: "게시 가능한 패키지"
    }), "\n", _jsx(_components.p, {
      children: "npm 레지스트리에 패키지를 게시하는 것은 이 페이지의 패키징 전략 중 가장 엄격한 요구 사항을 가지고 있습니다. 레지스트리에서 패키지를 다운로드하는 소비자가 패키지를 어떻게 사용할지 전혀 알 수 없기 때문에, 강력한 패키지를 위해 필요한 수많은 구성으로 인해 어려움을 겪을 수 있습니다."
    }), "\n", _jsxs(_components.p, {
      children: ["또한 npm 레지스트리에 패키지를 게시하는 프로세스에는 전문적인 지식과 도구가 필요합니다. 버전 관리, 변경 로그 및 게시 프로세스를 관리하기 위해 ", _jsx(_components.a, {
        href: "https://github.com/changesets/changesets",
        children: _jsx(_components.code, {
          children: "changesets"
        })
      }), "를 권장합니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["자세한 가이드는 ", _jsx(_components.a, {
        href: "/docs/guides/publishing-libraries",
        children: "패키지 게시 가이드"
      }), "를 참조하세요."]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
